import Swiper, {Navigation} from 'swiper';

const headerSocketSlider = () => {
    if (document.querySelector('.kirinus-header-socket') && document.querySelector('.kirinus-speciality-selector')) {
        const createSlide = (title, link) => {
            let parent = document.createElement('div');
            parent.classList.add('swiper-slide');
            let theLink = document.createElement('a');
            theLink.href = link;
            theLink.title = title;
            theLink.innerHTML = title;
            parent.appendChild(theLink);
            return parent;
        }
        let isTooWide = false;
        let socket = document.querySelector('.kirinus-header-socket');
        let slider = socket.querySelector('.swiper');
        let wrapper = slider.querySelector('.swiper-wrapper');
        let specialitySelector = document.querySelector('.kirinus-speciality-selector');
        let cards = specialitySelector.querySelectorAll('.card');
        if (wrapper.querySelector('.swiper-slide') == null) {
            if (cards.length > 0) {
                cards.forEach(card => {
                    let title = card.querySelector('.card-title').innerHTML;
                    let link = card.querySelector('.card-footer').querySelector('a');
                    if(title !== null && link !== null){
                        let newElement = createSlide(title, link);
                        wrapper.appendChild(newElement);
                    }

                });
            }
        }


        let sliderWidth = slider.offsetWidth;

        let allSlides = slider.querySelectorAll('.swiper-slide');
        let widthOfSlides = 0;
        let countSlidesInViewport = 0;
        let controls = socket.querySelector('.swiper-nav');


        allSlides.forEach(slide => {
            widthOfSlides += slide.offsetWidth;
            isTooWide = true;
            if (widthOfSlides < sliderWidth) {
                isTooWide = false;
                countSlidesInViewport++;
            }
        });
        Swiper.use([Navigation]);
        const swiper = new Swiper(slider, {
            slidesPerView: 'auto',
            enabled: false,
            navigation: {
                nextEl: controls.querySelector('.swiper-button-next'),
                prevEl: controls.querySelector('.swiper-button-prev'),
            },
        })
        /*       swiper.on('slideChange', function () {

                   if (swiper.isEnd) {

                       swiper.params.autoplay.reverseDirection = true;
                   }
                   if (swiper.isBeginning) {

                       swiper.params.autoplay.reverseDirection = false;
                   }
               })*/
        if (isTooWide) {
            controls.classList.remove('d-none');
            slider.classList.add('has-controls-enabled')
            swiper.enable();
        } else {
            controls.classList.add('d-none');
            slider.classList.remove('has-controls-enabled')
            swiper.disable();
        }

    }

}
export default headerSocketSlider;